import React from 'react'

function Foreclosures2() {
  return (
    <div  className='foreclosures2-container'>
		<div class="foreclosures2--link-container">
			<div class="letter-section">
				<h4>A</h4>
				<ul>
					<li><a href="/foreclosure/search/alabama.mvc">Alabama Foreclosures</a></li>
					<li><a href="/foreclosure/search/alaska.mvc">Alaska Foreclosures</a></li>
					<li><a href="/foreclosure/search/arizona.mvc">Arizona Foreclosures</a></li>
					<li><a href="/foreclosure/search/arkansas.mvc">Arkansas Foreclosures</a></li>
				</ul>

				<h4>C</h4>
				<ul>
					<li><a href="/foreclosure/search/california.mvc">California Foreclosures</a></li>
					<li><a href="/foreclosure/search/colorado.mvc">Colorado Foreclosures</a></li>
					<li><a href="/foreclosure/search/connecticut.mvc">Connecticut Foreclosures</a></li>
				</ul>

				<h4>D</h4>
				<ul>
					<li><a href="/foreclosure/search/delaware.mvc">Delaware Foreclosures</a></li>
					<li><a href="/foreclosure/search/district-of-columbia.mvc">DC Foreclosures</a></li>
				</ul>

				<h4>F</h4>
				<ul>
					<li><a href="/foreclosure/search/florida.mvc">Florida Foreclosures</a></li>
				</ul>

				<h4>G</h4>
				<ul>
					<li><a href="/foreclosure/search/georgia.mvc">Georgia Foreclosures</a></li>
				</ul>

				<h4>H</h4>
				<ul>
					<li><a href="/foreclosure/search/hawaii.mvc">Hawaii Foreclosures</a></li>
				</ul>

				<h4>I</h4>
				<ul>
					<li><a href="/foreclosure/search/idaho.mvc">Idaho Foreclosures</a></li>
					<li><a href="/foreclosure/search/illinois.mvc">Illinois Foreclosures</a></li>
					<li><a href="/foreclosure/search/indiana.mvc">Indiana Foreclosures</a></li>
					<li><a href="/foreclosure/search/iowa.mvc">Iowa Foreclosures</a></li>
				</ul>
			</div>
			<div class="letter-section">
				<h4>K</h4>
				<ul class="small-list">
					<li><a href="/foreclosure/search/kansas.mvc">Kansas Foreclosures</a></li>
					<li><a href="/foreclosure/search/kentucky.mvc">Kentucky Foreclosures</a></li>
				</ul>

				<h4>L</h4>
				<ul class="small-list">
					<li><a href="/foreclosure/search/louisiana.mvc">Louisiana Foreclosures</a></li>
				</ul>

				<h4>M</h4>
				<ul class="small-list">
					<li><a href="/foreclosure/search/maine.mvc">Maine Foreclosures</a></li>
					<li><a href="/foreclosure/search/maryland.mvc">Maryland Foreclosures</a></li>
					<li><a href="/foreclosure/search/massachusetts.mvc">Massachusetts Foreclosures</a></li>
					<li><a href="/foreclosure/search/michigan.mvc">Michigan Foreclosures</a></li>
					<li><a href="/foreclosure/search/minnesota.mvc">Minnesota Foreclosures</a></li>
					<li><a href="/foreclosure/search/mississippi.mvc">Mississippi Foreclosures</a></li>
					<li><a href="/foreclosure/search/missouri.mvc">Missouri Foreclosures</a></li>
					<li><a href="/foreclosure/search/montana.mvc">Montana Foreclosures</a></li>
				</ul>

				<h4>N</h4>
				<ul class="small-list">
					<li><a href="/foreclosure/search/nebraska.mvc">Nebraska Foreclosures</a></li>
					<li><a href="/foreclosure/search/nevada.mvc">Nevada Foreclosures</a></li>
					<li><a href="/foreclosure/search/new-hampshire.mvc">New Hampshire Foreclosures</a></li>
					<li><a href="/foreclosure/search/new-jersey.mvc">New Jersey Foreclosures</a></li>
					<li><a href="/foreclosure/search/new-mexico.mvc">New Mexico Foreclosures</a></li>
					<li><a href="/foreclosure/search/new-york.mvc">New York Foreclosures</a></li>
					<li><a href="/foreclosure/search/north-carolina.mvc">North Carolina Foreclosures</a></li>
					<li><a href="/foreclosure/search/north-dakota.mvc">North Dakota Foreclosures</a></li>
				</ul>

				<h4>O</h4>
				<ul class="small-list">
					<li><a href="/foreclosure/search/ohio.mvc">Ohio Foreclosures</a></li>
					<li><a href="/foreclosure/search/oklahoma.mvc">Oklahoma Foreclosures</a></li>
					<li><a href="/foreclosure/search/oregon.mvc">Oregon Foreclosures</a></li>
				</ul>
			</div>
			<div class="letter-section">
				<h4>P</h4>
				<ul class="small-list">
					<li><a href="/foreclosure/search/pennsylvania.mvc">Pennsylvania Foreclosures</a></li>
				</ul>

				<h4>R</h4>
				<ul class="small-list">
					<li><a href="/foreclosure/search/rhode-island.mvc">Rhode Island Foreclosures</a></li>
				</ul>

				<h4>S</h4>
				<ul class="small-list">
					<li><a href="/foreclosure/search/south-carolina.mvc">South Carolina Foreclosures</a></li>
					<li><a href="/foreclosure/search/south-dakota.mvc">South Dakota Foreclosures</a></li>
				</ul>

				<h4>T</h4>
				<ul class="small-list">
					<li><a href="/foreclosure/search/tennessee.mvc">Tennessee Foreclosures</a></li>
					<li><a href="/foreclosure/search/texas.mvc">Texas Foreclosures</a></li>
				</ul>

				<h4>U</h4>
				<ul class="small-list">
					<li><a href="/foreclosure/search/utah.mvc">Utah Foreclosures</a></li>
				</ul>

				<h4>V</h4>
				<ul class="small-list">
					<li><a href="/foreclosure/search/vermont.mvc">Vermont Foreclosures</a></li>
					<li><a href="/foreclosure/search/virginia.mvc">Virginia Foreclosures</a></li>
				</ul>

				<h4>W</h4>
				<ul class="small-list">
					<li><a href="/foreclosure/search/washington.mvc">Washington Foreclosures</a></li>
					<li><a href="/foreclosure/search/district-of-columbia.mvc">Washington DC Foreclosures</a></li>
					<li><a href="/foreclosure/search/west-virginia.mvc">West Virginia Foreclosures</a></li>
					<li><a href="/foreclosure/search/wisconsin.mvc">Wisconsin Foreclosures</a></li>
					<li><a href="/foreclosure/search/wyoming.mvc">Wyoming Foreclosures</a></li>
				</ul>
			</div>
		</div>
		<div className='foreclosures2--card-container'>
			<div className='foreclosures2--card'>
				<p className='foreclosures2--card-title mb-4'>Find Real Estate Listings</p>
				<p className='foreclosures2--card-sub mb-4'>Search for listings near you.</p>
				<div className="mb-3">
					<input type="email" class="form-control" id="exampleFormControlInput1" placeholder="City"/>
				</div>

				<div className='mb-3'>
					<select className="form-select" style={{width:'100%'}} aria-label="Default select example">
						<option value="">Select State</option>
						<option value="AL">Alabama</option>
						<option value="AK">Alaska</option>
						<option value="AZ">Arizona</option>
						<option value="AR">Arkansas</option>
						<option value="CA">California</option>
						<option value="CO">Colorado</option>
						<option value="CT">Connecticut</option>
						<option value="DE">Delaware</option>
						<option value="DC">District of Columbia</option>
						<option value="FL">Florida</option>
						<option value="GA">Georgia</option>
						<option value="HI">Hawaii</option>
						<option value="ID">Idaho</option>
						<option value="IL">Illinois</option>
						<option value="IN">Indiana</option>
						<option value="IA">Iowa</option>
						<option value="KS">Kansas</option>
						<option value="KY">Kentucky</option>
						<option value="LA">Louisiana</option>
						<option value="ME">Maine</option>
						<option value="MD">Maryland</option>
						<option value="MA">Massachusetts</option>
						<option value="MI">Michigan</option>
						<option value="MN">Minnesota</option>
						<option value="MS">Mississippi</option>
						<option value="MO">Missouri</option>
						<option value="MT">Montana</option>
						<option value="NE">Nebraska</option>
						<option value="NV">Nevada</option>
						<option value="NH">New Hampshire</option>
						<option value="NJ">New Jersey</option>
						<option value="NM">New Mexico</option>
						<option value="NY">New York</option>
						<option value="NC">North Carolina</option>
						<option value="ND">North Dakota</option>
						<option value="OH">Ohio</option>
						<option value="OK">Oklahoma</option>
						<option value="OR">Oregon</option>
						<option value="PA">Pennsylvania</option>
						<option value="RI">Rhode Island</option>
						<option value="SC">South Carolina</option>
						<option value="SD">South Dakota</option>
						<option value="TN">Tennessee</option>
						<option value="TX">Texas</option>
						<option value="UT">Utah</option>
						<option value="VT">Vermont</option>
						<option value="VA">Virginia</option>
						<option value="WA">Washington</option>
						<option value="WV">West Virginia</option>
						<option value="WI">Wisconsin</option>
						<option value="WY">Wyoming</option>
					</select>
				</div>

				<div className="mb-3">
					<input type="text" class="form-control" id="exampleFormControlInput1" placeholder="Zip"/>
				</div>

				<div className="mb-3">
					<input type="text" class="form-control" id="exampleFormControlInput1" placeholder="Country"/>
				</div>

				{/* <div className='mb-3'>
					<select className="form-select" style={{width:'100%'}} aria-label="Default select example">
						<option value="0">No minimum</option>
						<option value="100000">$100,000</option>
						<option value="150000">$150,000</option>
						<option value="160000">$160,000</option>
						<option value="170000">$170,000</option>
						<option value="180000">$180,000</option>
						<option value="190000">$190,000</option>
						<option value="200000">$200,000</option>
						<option value="220000">$220,000</option>
						<option value="240000">$240,000</option>
						<option value="260000">$260,000</option>
						<option value="280000">$280,000</option>
						<option value="300000">$300,000</option>
						<option value="325000">$325,000</option>
						<option value="350000">$350,000</option>
						<option value="375000">$375,000</option>
						<option value="400000">$400,000</option>
						<option value="425000">$425,000</option>
						<option value="450000">$450,000</option>
						<option value="475000">$475,000</option>
						<option value="500000">$500,000</option>
						<option value="600000">$600,000</option>
						<option value="700000">$700,000</option>
						<option value="800000">$800,000</option>
						<option value="900000">$900,000</option>
						<option value="1000000">$1,000,000+</option>
					</select>
				</div>

				<div className='mb-3'>
					<select className="form-select" style={{width:'100%'}} aria-label="Default select example">
						<option value="0">No maximum</option>
						<option value="100000">$100,000</option>
						<option value="150000">$150,000</option>
						<option value="160000">$160,000</option>
						<option value="170000">$170,000</option>
						<option value="180000">$180,000</option>
						<option value="190000">$190,000</option>
						<option value="200000">$200,000</option>
						<option value="220000">$220,000</option>
						<option value="240000">$240,000</option>
						<option value="260000">$260,000</option>
						<option value="280000">$280,000</option>
						<option value="300000">$300,000</option>
						<option value="325000">$325,000</option>
						<option value="350000">$350,000</option>
						<option value="375000">$375,000</option>
						<option value="400000">$400,000</option>
						<option value="425000">$425,000</option>
						<option value="450000">$450,000</option>
						<option value="475000">$475,000</option>
						<option value="500000">$500,000</option>
						<option value="600000">$600,000</option>
						<option value="700000">$700,000</option>
						<option value="800000">$800,000</option>
						<option value="900000">$900,000</option>
						<option value="1000000">$1,000,000+</option>
					</select>
				</div> */}
				<button>SEARCH</button>
			</div>
		</div>
    </div>
  )
}

export default Foreclosures2